import ApiService from '../api.service';

const BuyingInterestResource = {
  createBuyingInterest: (params) => ApiService.post(`/v1/business/${params.business_id}/buying_interests`, params),
  indexBuyingInterest: (params) => ApiService.get(`/v1/business/${params.business_id}/buying_interests`),
  removeBuyingInterest: (params) => ApiService.delete(`/v1/business/${params.business_id}/buying_interests/${params.id}`),
};

export default BuyingInterestResource;
